export const isFormu2Submission = (submission) => submission?.form_variant === 'formu2';

export const isLegacyAudioEnabled = (submission) => (
  submission?.affirmation_audio?.legacy_audio_enabled === true
);

export const isAudioEnabledSubmission = (submission) => (
  isFormu2Submission(submission) || isLegacyAudioEnabled(submission)
);

export const canRequestAudioForSubmission = (submission) => (
  isFormu2Submission(submission) || submission?.status === 'finalized'
);
